// extracted by mini-css-extract-plugin
module.exports =  {"verification":"KSPWd2SvKOlpqkrWheav","verified":"Me59Ai7kJlyiWdKaAFqk"};